import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=a2180a26&scoped=true"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&id=a2180a26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2180a26",
  null
  
)

export default component.exports